import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { FilterContext } from "contextos/FilterContext";
import styles from "./DropDownInput.module.scss";
// import { IdiomaContext } from "contextos/IdiomaFacetContext";
// import { getMoreLenguajes } from "services/libraryServices";
// import LoadingBox from "components/loadingBox/loadingBox";

const DropDownInput = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const { handleSubmit } = useContext(FilterContext);
  // const [currentFocus, setcurrentFocus] = useState("");
  // const { submitForm, setMySelectedPhotos } = useContext(IdiomaContext);

  useEffect(() => {
    if (props?.actualColection) {
      setValue(props?.actualColection?.value);
    }
    setLoading(false);
  }, [setLoading, props?.actualColection]);

  useEffect(() => {
    const name = props.name;
    if (name === "repository") {
      return;
    }
    if (search.get(name) && props?.cambio == null) {
      let value = search.get(name);
      if (props?.options.some((el) => el.value === value)) {
        setValue(search.get(name));
      } else {
        setValue("");
      }
    }
  }, [search, props?.options, props?.cambio, props.name]);

  // const getMore = async () => {
  //   setLoading(true);
  //   const forms = document.getElementsByName("searchForm");
  //   const newLength = props.options.length - 2 + 6;
  //   var urlQuery = `?${submitForm(
  //     forms[1].elements,
  //     true
  //   )}&respp=1&lengResp=${newLength}`;
  //   urlQuery = urlQuery.replace("&idioma=more", "");
  //   const newFacet = await getMoreLenguajes(urlQuery, newLength);
  //   setMySelectedPhotos((prev) => ({ ...prev, idiomaFacet: newFacet }));
  //   setLoading(false);
  // };

  return (
    <div>
      {!loading && (
        <select
          className={`${styles.select} form-select`}
          id={props.name}
          name={props.name}
          onChange={async (e) => {
            if (props?.cambio) {
              await props.cambio(e.target.value);
            } else {
              await setValue(e.target.value);
            }
            handleSubmit();
          }}
          value={value}

          // onFocus={(e) => {
          //   setcurrentFocus(e.target.value);
          // }}
          // onBlur={(e) => {
          //   if (e.target.value !== currentFocus) {
          //     handleSubmit();
          //   }
          // }}
        >
          {props.options.map((option) => {
            return (
              <option
                value={option.value !== " " ? option.value : ""}
                key={option.value}
                disabled={option?.disabled === true ? option.disabled : false}
              >
                {option.displayText}
              </option>
            );
          })}
        </select>
      )}
      {/* {loading && <LoadingBox justItem={true} />} */}
    </div>
  );
};

export default DropDownInput;
